import { __awaiter, __generator } from "tslib";
import { Simulate } from 'react-dom/test-utils';
export function createFloaterSelectDriver(wrapper) {
    var _this = this;
    var base = wrapper.$('.floater-select');
    var searchField = base.$('.search-wrapper .search-input input.input-field');
    return {
        getItemsContent: function (innerSelector) {
            return base.$$('.floater-select-item').map(function (item) { return innerSelector ? item.$(innerSelector).text() : item.text(); });
        },
        search: function (term) { return searchField.enterValue(term); },
        pressDownKey: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('not implemented');
            });
        }); },
        pressEnterKey: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('not implemented');
            });
        }); },
        isLoading: function () { return base.$('.loader').exists(); },
        /**
        * @deprecated use `select` instead
        */
        selectDeprecated: function (idx) { return base.$$('.floater-select-item').get(idx).getNative().then(function (el) { return Simulate.mouseDown(el); }); },
        select: function (idx) { return base.$$('.floater-select-item').get(idx).click(); },
        base: base
    };
}
//# sourceMappingURL=driver.js.map